export default __webpack_public_path__ + "static/media/fruit-1920w.e7d7e43f.png";